const normalizar = (texto: string) =>
  texto
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9ñ ]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

// Devolve as opções que contêm todas as palavras digitadas (sem acento, em qualquer ordem).
// Ordem: começa com o texto digitado > alguma palavra começa com ele > só contém. Empate: a
// ordem original da lista, que já vem da mais relevante para a menos.
export const autocompletar = (digitado: string, opcoes: string[], limite = 6) => {
  const consulta = normalizar(digitado);
  if (consulta.length < 2) return [];
  const palavras = consulta.split(" ");

  return opcoes
    .map((texto, ordem) => {
      const alvo = normalizar(texto);
      if (!palavras.every((p) => alvo.includes(p)) || alvo === consulta) return null;
      const nota = alvo.startsWith(consulta) ? 0 : ` ${alvo}`.includes(` ${palavras[0]}`) ? 1 : 2;
      return { texto, nota, ordem };
    })
    .filter((item): item is { texto: string; nota: number; ordem: number } => item !== null)
    .sort((a, b) => a.nota - b.nota || a.ordem - b.ordem)
    .slice(0, limite)
    .map((item) => item.texto);
};

// Divide o texto em trechos para destacar em negrito as palavras digitadas.
export const destacar = (texto: string, digitado: string) => {
  const palavras = normalizar(digitado).split(" ").filter((p) => p.length > 1);
  if (!palavras.length) return [{ trecho: texto, destaque: false }];

  const semAcento = texto.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
  const marcado = new Array(texto.length).fill(false);
  for (const p of palavras) {
    let i = semAcento.indexOf(p);
    while (i !== -1) {
      for (let j = i; j < i + p.length; j++) marcado[j] = true;
      i = semAcento.indexOf(p, i + p.length);
    }
  }

  const trechos: { trecho: string; destaque: boolean }[] = [];
  for (let i = 0; i < texto.length; i++) {
    const ultimo = trechos[trechos.length - 1];
    if (ultimo && ultimo.destaque === marcado[i]) ultimo.trecho += texto[i];
    else trechos.push({ trecho: texto[i], destaque: marcado[i] });
  }
  return trechos;
};
